import { Injectable } from '@angular/core';
import { RESTServiceBase } from '../../common/service.base';
import { LabelDescriptor } from './model/label';
import { List } from '../../common/model/List_T';
import { AppConfig } from '../../configuration/app.config';
import { AuthService } from '../../services/auth.service';
import { View } from '../../common/model/view';

@Injectable()
export class LabelService extends RESTServiceBase {

  constructor(
    authService: AuthService,
    config: AppConfig
  ) {
    super(
      'v1',
      'LabelManagement',
      authService,
      config.LMSConfig
    );
  }

  public create(label: LabelDescriptor): Promise<LabelDescriptor> {
    return super.post<LabelDescriptor>(
      new LabelDescriptor({
        id: undefined,
        href: undefined,
        name: label.name,
        description: label.description,
        clerkId: label.clerkId,
        usedForDataEntryCreation: label.usedForDataEntryCreation,
        modified: label.modified,
        deleted: label.deleted
      }));
  }

  public getLabels(view?: View): Promise<List<LabelDescriptor>> {
    return super.get<List<LabelDescriptor>>(undefined, view);
  }

  async GetList(v: View): Promise<List<LabelDescriptor>> {
    return await this.getLabels(v);
  }
  async GetById(id: string): Promise<LabelDescriptor> {
    return await this.getById(id);
  }

  public delete(id: string): Promise<void> {
    return super.delete(id);
  }

  public update(id: string, role: LabelDescriptor): Promise<LabelDescriptor> {
    return super.put<LabelDescriptor>(id, role);
  }

  public getById(id: string): Promise<LabelDescriptor> {
    return super.get<LabelDescriptor>(id);
  }

  public async isServiceAvailable(): Promise<boolean> {
    return await super.isServiceAvailable();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/label/label.service.ts